import type { InstitutionFullDto, BranchDto } from '../model/types'
import { useApi } from '@shared/api'

export interface InstitutionResponse {
  institution: InstitutionFullDto
  branches: BranchDto[]
}

/** Кандидат авто-роутинга доставки. */
export interface ResolveDeliveryBranchCandidate {
  branchId: string
  branchName: string
  zoneId: string
  distanceKm: number | null
  loaded: boolean
}

/** Ответ авто-роутинга доставки: в какой филиал уйдёт заказ по адресу. */
export interface ResolveDeliveryBranchResponse {
  /** Адрес вне всех зон доставки */
  outOfZone: boolean
  /** Адрес в зоне, но ни один обслуживающий филиал не делает весь состав корзины */
  cartUnavailable: boolean
  branchId: string | null
  zoneId: string | null
  distanceKm: number | null
  /** Подобранный филиал загружен (true только в fallback, когда все загружены) */
  loaded: boolean
  /** Все подходящие филиалы загружены — выбран ближайший как fallback */
  allLoaded: boolean
  candidates: ResolveDeliveryBranchCandidate[]
}

class APIInstitutions {
  /**
   * Получить полную информацию о заведении по ID.
   * GET /api/v2/institutions/{id}
   *
   * Возвращает: данные заведения, список филиалов, зоны доставки, уровни лояльности.
   */
  getInstitution(institutionId: number) {
    return useApi(true).get<InstitutionResponse>(`/institutions/${institutionId}`)
  }

  /**
   * Авто-роутинг доставки: по координатам адреса подобрать филиал.
   * POST /api/v2/institutions/{id}/resolve-delivery-branch
   */
  resolveDeliveryBranch(
    institutionId: number,
    body: {
      latitude: number
      longitude: number
      orderSum?: number
      productIds?: string[]
      comboIds?: string[]
    },
  ) {
    return useApi(true).post<ResolveDeliveryBranchResponse>(
      `/institutions/${institutionId}/resolve-delivery-branch`,
      { body },
    )
  }
}

export const apiInstitutions = new APIInstitutions()
export default apiInstitutions
